export enum AnalyticsEvent {
  OnboardingStart = "onboarding_start",
  AuthSkip = "auth_skip",
  AuthIntent = "auth_intent",
  AuthOtp = "auth_otp",
  SubscriptionStatus = "subscription_status",
  BundleCodeActivate = "bundle_code_activate",
  PaywallView = "paywall_view",
  PaywallSelect = "paywall_select",
  TvLinkGrant = "tv_link_grant",
  TvLinkAttempt = "tv_link_attempt",
  ProfileSetup = "profile_setup",
  HomepageAction = "homepage_action",
  NavbarAction = "navbar_action",
  GameSelect = "game_select",
  GameBuy = "game_buy",
  GameViewIgdb = "game_view_igdb",
  GameLaunchStart = "game_launch_start",
  // update new GA4
  GameLaunchStarting = "game_launch_starting",
  GameLaunchSteamLogin = "game_launch_steamlogin",
  GameLaunchSteamLoginSuccess = "game_launch_steamlogin_success",
  GameLaunchEula = "game_launch_eula",
  GameLaunchGameLaunching = "game_launch_gamelaunching",
  GameLaunchGameLaunchTimeout = "game_launch_gamelaunch_timeout",
  GameLaunchGameRunning = "game_launch_gamerunning",
  GameLaunchGameExited = "game_launch_gameexited",
  GameLaunchInQueue = "game_launch_in_queue",
  GameLaunchNotActive = "game_launch_notactive",
  GameLaunchLaunchingDisconnected = "game_launch_launching_disconnected",
  GameLaunchInactivityTimeout = "game_launch_inactivity_timeout",
  GameLaunchGameRunningUpdatePending = "game_launch_gamerunning_updatepending",
  GameLaunchGameRunningDisconnected = "game_launch_gamerunning_disconnected",
  GameLaunchClientDisconnected = "game_launch_clientdisconnected",
  GameLaunchUpdateDetected = "game_launch_updatedetected",

  GameOverlayAction = "game_overlay_action",
  GamePerformanceWarning = "game_performance_warning",
  GameSessionEnd = "game_session_end",
  SubscriptionCancel = "subscription_cancel",
  SubscriptionTransaction = "subscription_transaction",
}

interface IUserProperties {
  sub_status?: string;
  controllers?: number;
}

export const GTM_ID = "GTM-5QLW93VX";

export interface IAnalyticsParams {
  event_name: AnalyticsEvent;
  user_id?: string;
  ui_nu?: string;
  user_properties?: IUserProperties;
  source?: string;
  type?: string;
  value?: string | number;
  game_session_id?: string;
  session_time?: string;
  status?: string;
  error?: string;
}
